import React, { useState } from 'react';

import Search from '../../Components/Search'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function InformRegionalManagerSubstitute(props) {
    const [ loadingRegionalManager, setLoadingRegionalManager ] = useState(false);   

    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [ cpfSearchErro, setCpfSearchErro] = useState(false);
    const [ cpfSearchErroMessage, setCpfSearchErroMessage ] = useState("");
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const removeInputMask = (cpf) => {
        if (cpf === "") {
            return ""
        } else {
            return cpf.replace(/[^\d]+/g, "");
        }
    };

    const onSubmitCPF = async (data) => {

        data.cpf = removeInputMask(data.cpf);
        setCpfSearchErro(false);

        setLoadingRegionalManager(true);

        const loggedUser = JSON.parse(localStorage.getItem('user'));

        // Buscando dados do Gestor Atual (que vai ser substituido)

        const requestOptionsGRAtual = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': loggedUser ? loggedUser.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: loggedUser ? loggedUser.cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                perfil: 'R',
                cpf_usuario: props.location.state.result_search.CPF_USUARIO_CADASTRADOR
            }),
        };

        const state = {}

        await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaGestor`, requestOptionsGRAtual).then((response) => {
            if (response.ok) {
                response.json().then((gestorAtual) => {
                    state.regional_manager = {
                        atendente: props.location.state.result_search.CPF_USUARIO,
                        id_usuario_orgao: gestorAtual.ID_USUARIO_ORGAO,
                        cpf: gestorAtual.CPF_USUARIO,
                        name: gestorAtual.NOME_USUARIO,
                        organ: {
                            value: gestorAtual.CODIGO_ORGAO,
                            label: gestorAtual.NOME_ORGAO
                        },
                        unidade: {
                            value: gestorAtual.CODIGO_UNIDADE,
                            label: gestorAtual.NOME_UNIDADE
                        },
                        dt_inc: gestorAtual.DATA_INCLUSAO,
                        dt_canc_exp: gestorAtual.DATA_CANCELAMENTO
                    }
                })
            }
        })

        // Buscando dados do Gestor Substituto

        const requestOptionsGRSubstituto = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': loggedUser ? loggedUser.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: loggedUser ? loggedUser.cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                cpf_gestor_regional_original: props.location.state.result_search.CPF_USUARIO,
                cpf_gestor_regional: data.cpf,
                codigo_orgao: props.location.state.result_search.CODIGO_ORGAO,
                codigo_unidade: props.location.state.result_search.CODIGO_UNIDADE               
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/consultaGestorRegionalSubstituto`, requestOptionsGRSubstituto).then( 
            function(response) {
            if (response.ok) {
                response.json().then(function(data_substituto) {

                    console.log('*** data_substituto', data_substituto)

                    state.regional_manager_substitute = {
                            id_usuario_orgao: data_substituto.id_usuario_orgao,
                            cpf: data_substituto.cpf_gestor_regional,
                            name: data_substituto.nome_gestor_regional,
                            organ: {
                                value: data_substituto.codigo_orgao,
                                label: data_substituto.nome_orgao
                            },
                            unidade: {
                                value: data_substituto.codigo_unidade,
                                label: data_substituto.nome_unidade
                            },
                            dt_inc: data_substituto.data_inclusao,
                            dt_canc_exp: data_substituto.data_cancelamento
                        }
                        
                    
                    setLoadingRegionalManager(false);

                    props.history.push("/substituirGestorRegional", state);

                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setCpfSearchErro(true);
                        setCpfSearchErroMessage(data.message);
                    } else {
                        // inserir mensagem genérica
                        setCpfSearchErro(true);
                        setCpfSearchErroMessage('Houve algum problema no servidor.');
                    }

                    setLoadingRegionalManager(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingRegionalManager(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingRegionalManager(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return ( 
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <Search
                pageTitle='Substituir gestor regional'
                cpfLabel='CPF do gestor regional substituto'
                buttonBackRoute='/gerenciarGestoresRegionais'
                messageError={messageError}
                onSubmitCPF={onSubmitCPF}
                modalError={modalError}
                setModalError={setModalError}
                buttonNextLoading={loadingRegionalManager}
                cpfSearchErro={cpfSearchErro}
                setCpfSearchErro={setCpfSearchErro}
                cpfSearchErroMessage={cpfSearchErroMessage}
                history={props.history}
            />
        </>
    );
}